export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/tuner-icon.svg?38ebbe6eeb2d21b95c1e636954f2e1c9";